import { render, staticRenderFns } from "./messagePush.vue?vue&type=template&id=67eb553e&"
import script from "./messagePush.vue?vue&type=script&lang=js&"
export * from "./messagePush.vue?vue&type=script&lang=js&"
import style0 from "./messagePush.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports